import { createContext, useContext, useEffect, useRef, useState } from "react";

const HeaderContext = createContext();

export const HeaderProvider = ({ children }) => {
  const headerRef = useRef(null);
  const [marginTop, setMarginTop] = useState(0);

  useEffect(() => {
    if (!headerRef.current) return;

    const updateMargin = () => {
      const headerHeight = headerRef.current.offsetHeight;
      const windowHeight = window.innerHeight;
      setMarginTop(windowHeight - headerHeight);
    };

    updateMargin();
    window.addEventListener("resize", updateMargin);

    // --- Escuchar eventos de collapse ---
    const collapseEl = document.getElementById("navbarNav");
    if (collapseEl) {
      const handleShown = () => updateMargin();
      const handleHidden = () => updateMargin();

      collapseEl.addEventListener("shown.bs.collapse", handleShown);
      collapseEl.addEventListener("hidden.bs.collapse", handleHidden);

      return () => {
        window.removeEventListener("resize", updateMargin);
        collapseEl.removeEventListener("shown.bs.collapse", handleShown);
        collapseEl.removeEventListener("hidden.bs.collapse", handleHidden);
      };
    }

    return () => window.removeEventListener("resize", updateMargin);
  }, []);

  return <HeaderContext.Provider value={{ headerRef, marginTop }}>{children}</HeaderContext.Provider>;
};

export const useHeader = () => useContext(HeaderContext);
